import React from 'react';
import { Image as ImageIcon } from 'lucide-react';
import { Link } from 'react-router-dom';

const Fotogalerie = () => {
  const galleries = [
    {
      id: 'paleni-carodejnic',
      title: 'Pálení čarodějnic',
      description: 'Tradiční pálení čarodějnic',
      color: 'from-orange-500 to-red-600'
    },
    {
      id: 'detsky-den',
      title: 'Dětský den',
      description: 'Zábava pro nejmenší',
      color: 'from-pink-500 to-purple-600'
    },
    {
      id: 'vodo-lodni-soutez',
      title: 'Vodo-lodní soutěž',
      description: 'Soutěž na vodě',
      color: 'from-blue-500 to-cyan-600'
    },
    {
      id: 'kotlikovy-gulas',
      title: 'Kotlíkový guláš',
      description: 'Soutěž ve vaření guláše',
      color: 'from-green-500 to-emerald-600'
    },
    {
      id: 'ukonceni-prazdnin',
      title: 'Ukončení prázdnin',
      description: 'Rozloučení s létem',
      color: 'from-yellow-500 to-orange-600'
    }
  ];

  return (
    <section className="py-16 px-4 bg-gray-50 min-h-screen" data-testid="fotogalerie-section">
      <div className="container mx-auto max-w-6xl">
        <div className="text-center mb-12">
          <ImageIcon className="w-16 h-16 mx-auto text-blue-600 mb-4" />
          <h2 className="text-4xl font-bold text-gray-800 mb-2">Fotogalerie</h2>
          <p className="text-gray-600 text-lg">Vyberte akci pro prohlížení fotografií</p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {galleries.map((gallery) => (
            <Link
              key={gallery.id}
              to={`/fotogalerie/${gallery.id}`}
              className="group block"
              data-testid={`gallery-card-${gallery.id}`}
            >
              <div className="bg-white rounded-xl shadow-md hover:shadow-2xl transition-all duration-300 overflow-hidden transform hover:-translate-y-2 border border-gray-100">
                {/* Tenký dekorativní pruh nahoře */}
                <div className={`h-2 bg-gradient-to-r ${gallery.color}`}></div>
                
                <div className="p-8">
                  <h3 className="text-2xl font-bold text-gray-800 mb-3 group-hover:text-blue-600 transition-colors">
                    {gallery.title}
                  </h3>
                  <p className="text-gray-600 text-base mb-6">{gallery.description}</p>
                  <div className="flex items-center text-blue-600 font-semibold">
                    <span>Zobrazit fotky</span>
                    <svg className="w-5 h-5 ml-2 group-hover:translate-x-2 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                    </svg>
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Fotogalerie;
